<template>

  <div class="atividades-sacsolicitacoes ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="6">
                <label for="select-garagem">Garagem</label>  
                <multiselect  v-model="value_garagem" required 
                  :options="garagens" 
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a garagem" label="garagem" track-by="garagem" name="garagem"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Garagem selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="4">
                   <label for="select-status">Status</label>  

                <multiselect id="selecaostatus" v-model="value_status"  required
                :options="statuss" 
                :multiple="true"                 
                :close-on-select="false" 
                :clear-on-select="true" 
                :preserve-search="true" placeholder="Status" label="status" track-by="status" name="status"
                :preselect-first="false">
                <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} status selecionado</span></template>
                </multiselect>                
              </b-col> 

              <b-col cols="2">
                <br>                 
                <b-button variant="primary" class="mr-2 mt-2" :disabled="carregando" @click="carregando = true,loadSacSolicitacoes()">
                  <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                </b-button>                      
              </b-col>
          </b-row>
    </b-form>


    <b-col>
      <div >                     
       
       <b-progress class="mt-3 mp-3" :max="barra_limite">
        <b-progress-bar variant="success"  :value="barra_inicial" :label="`${((barra_inicial / barra_limite) * 100).toFixed(2)} %`"></b-progress-bar>
      </b-progress>

      </div>
    </b-col>


    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
    <b-table id="saclancamentos"  small hover striped sticky-header="550px"  :items="sacsolicitacoes" :fields="fields" >    
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="loadCarregaSac(data.item)"    title="Acessar Sac"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-multi-1>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div>        
    <b-modal id="modal-multi-1" cancel-title="Fechar" ok-title="Gravar" @ok="postSac(),loadSacSolicitacoes()"  size="xl" title="SAC - Solicitação.:"   no-close-on-esc no-close-on-backdrop>
          <!-- -->
          <div>

            <b-row>
              <input  id="id-sac" type="hidden" v-model="sacsolicitacao.id_solicitacao" />
              
              <b-col cols="5">
                <label for="input-live">Registro</label> 
                <b-form-input  id="re-solicitante" v-model="sacsolicitacao.re_solicitante" readonly placeholder="" class="mb-3"></b-form-input>
              </b-col>

              <b-col cols="5">
                <label for="input-live">Função</label>
                <b-form-input id="funcao" v-model="sacsolicitacao.funcao_solicitante" readonly placeholder=""></b-form-input>              
              </b-col>

            <b-col sm="5">
              <label for="input-parecer">Parecer</label>
              <div>                    
                <b-form-select   id="parecer"               
                  v-model="sacsolicitacao.id_status"  
                  :options="statuss"
                  class="mb-3"
                  text-field="status"                            
                >                
                </b-form-select>
              </div>
            </b-col> 

            <b-col sm="5">
              <label for="select-motivo">Motivo</label>     
              <div>                    
                <b-form-select   id="motivo"               
                  v-model="sacsolicitacao.id_motivo"  
                  :options="motivos"
                  class="mb-3"
                  text-field="motivo"                            
                >                
                </b-form-select>
              </div>
            </b-col> 
            </b-row> 

            <b-row>
              <b-col sm="3">
                <label for="textarea-small">Solicitação</label> 
              </b-col>
              <b-col sm="12">
                <b-form-textarea
                  id="id-pecas" 
                  v-model="sacsolicitacao.pergunta" 
                  readonly            
                  size="sm"
                  class="mb-3"
                  placeholder="Pergunta do colaborador"
                ></b-form-textarea>
              </b-col>
            </b-row> 

            <b-row>
              <b-col sm="12">
                <label for="textarea-small">Resposta</label>
                
              </b-col>
              <b-col sm="12">
                <b-form-textarea                   
                  id="id-obs"
                  v-model="sacsolicitacao.resposta"
                  size="sm"      
                  placeholder="Digite o parecer para o colaborador"
                ></b-form-textarea>
              </b-col>
            </b-row>

            <b-row>
              <b-col class="mb-3 mt-3 ml-5" >
                <div>
                  <b-img v-if="sacsolicitacao.file==='true'" :src="sacsolicitacao.file"  width="600" height="600"></b-img>
                </div>                              
              </b-col>
            </b-row>             
          </div>
          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->

  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'


export default {    
    name: 'SacSolicitacao',    

    data: function() {        
      
        return {
            mode: 'save',
            carregando: false,
            atualizando: false,            
            garagem:{}, 
            garagens: [],   // [] lista            
            value_garagem:[],// [] lista     
            
            status:{},
            statuss: [],   // [] lista            

            motivos:[],
                                     
            sacsolicitacao:{},// [] lista   
            sacsolicitacoes:[],// [] lista

            
            value_status:'',            
            
            barra_inicial: 0,         
            barra_limite: 60000,

            fields: [
                { key: 'id_solicitacao', label: 'Nº Solicitação', sortable: true },     
                { key: 'id_garagem', label: 'Garagem', sortable: true },                 
                { key: 're_solicitante', label: 'Solicitante', sortable: true },  
                { key: 'dt_abertura', label: 'Data Abertura', sortable: true, formatter: (value, key, sacsolicitacoes) => {
                    return moment(sacsolicitacoes.dt_abertura).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                { key: 'data_ocorrencia', label: 'Data Ocorrência', sortable: true, formatter: (value, key, sacsolicitacoes) => {
                    return moment(sacsolicitacoes.data_ocorrencia).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },

                { key: 'status', label: 'Status', sortable: true },  
                
                { key: 'tipo_solicitacao', label: 'Tipo da Solicitação', sortable: true },
                { key: 'titulo', label: 'Titulo', sortable: true },                
                { key: 'pergunta', label: 'Solicitação', sortable: true },                
                { key: 'dt_resposta', label: 'Data Resposta', sortable: true, formatter: (value, key, sacsolicitacoes) => {
                    return moment(sacsolicitacoes.dt_resposta).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },
                { key: 'motivo', label: 'Motivo', sortable: true },                
                { key: 'resposta', label: 'Resposta', sortable: true },  
                { key: 'tempo', label: 'Duração', sortable: true },             
                { key: 're_resposta', label: 'Respondido Por', sortable: true },       

                { key: 'actions', label: 'Ações' },                
            ]
        }        
    },

    components: {
        Multiselect
    },
    methods: {
      

      temporizador() {
      this.handle = setInterval(() =>{
        this.barra_inicial = this.barra_inicial + 1000
        if(this.barra_inicial >= this.barra_limite){
          this.barra_inicial = 0
          this.loadSacSolicitacoes()
        }
      },1000)
      },
      
        loadGaragens() {
          const url = `${baseApiUrl}/manutencao/rfi/garagem`
          axios.get(url).then(res => {
            this.garagens = res.data.map(garagem => {              
              return { id_filial: garagem.id_filial, garagem: garagem.garagem }
            })
          })
        },        

        loadStatus() {
          const url = `${baseApiUrl}/sac/status`
          axios.get(url).then(res => {
            this.statuss = res.data.map(sta => {              
               return { ... sta, value: sta.id_status, status: sta.status }
            })
          })
        },

        loadMotivo() {
          const url = `${baseApiUrl}/sac/motivo`
          axios.get(url).then(res => {
            this.motivos = res.data.map(mot => {              
               return { ... mot, value: mot.id_motivo, motivo: mot.motivo }
            })
          })
        },


        loadSacSolicitacoes() {                        
            let corpo = {    
                "id_garagem": `${[this.value_garagem.map(a => a.id_filial)]}`,                
                "id_status": `${[this.value_status.map(r => r.id_status)]}`                
            };
 
            const url = `${baseApiUrl}/sac/solicitacoes`            
            axios.post(url,corpo).then(res => {                                
                this.carregando = false;
                this.sacsolicitacoes = res.data.map(sacsolicitacao => {
                            return {                              
                              id_solicitacao: sacsolicitacao.id_solicitacao, 
                              empresa: sacsolicitacao.empresa, 
                              id_garagem: sacsolicitacao.id_garagem,
                              dt_abertura: sacsolicitacao.dt_abertura,
                              //data_sid_funcionario_solicitanteervico: sacsolicitacao.id_funcionario_solicitante, 
                              data_ocorrencia: sacsolicitacao.data_ocorrencia, 
                              re_solicitante: sacsolicitacao.re_solicitante,
                              funcao_solicitante: sacsolicitacao.funcao_solicitante,
                              id_tipo_solicitacao: sacsolicitacao.id_tipo_solicitacao,
                              tipo_solicitacao: sacsolicitacao.tipo_solicitacao,
                              titulo: sacsolicitacao.titulo, 
                              pergunta: sacsolicitacao.pergunta,
                              file: sacsolicitacao.file,
                              id_status: sacsolicitacao.id_status, 
                              status: sacsolicitacao.status, 
                              resposta: sacsolicitacao.resposta, 
                              dt_resposta: sacsolicitacao.dt_resposta,
                              id_funcionario_resposta: sacsolicitacao.id_funcionario_resposta,
                              re_resposta: sacsolicitacao.re_resposta,
                              funcao_resposta: sacsolicitacao.funcao_resposta,
                              id_motivo: sacsolicitacao.id_motivo,
                              motivo: sacsolicitacao.motivo,
                              tempo: sacsolicitacao.tempo                              
                            }              
                                                })
                        })            
        }, 

        loadCarregaSac(sacsolicitacao){
            this.sacsolicitacao = { ...sacsolicitacao }
        },

        postSac() {                        
        let corpo = { 
                "descricao_resposta": `${this.sacsolicitacao.resposta}`,
                "id_solicitacao": `${this.sacsolicitacao.id_solicitacao}`,
                "id_status": `${this.sacsolicitacao.id_status}`,
                "id_motivo": `${this.sacsolicitacao.id_motivo}`,
                "status": `${[this.statuss.filter(a => a.id_status == this.sacsolicitacao.id_status).map(a => a.status)]}`
        };

        const url = `${baseApiUrl}/sac/solicitacoes/save`   

            axios.post(url,corpo).then(() => {
                    this.$toasted.global.defaultSuccess()
                    //this.reset() limpar os objetos valores
                })
                .catch(showError)
        },
  
    },

    mounted() {                             
        this.temporizador()                  
        this.loadGaragens()  
        this.loadStatus()   
        this.loadMotivo()
        this.loadStatusApp()           
        this.loadSolicitcaoes()
        this.loadCarregaSac()      
        
    },
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#selecaostatusx{
    font-size: 0.7em;      
}

#rfilancamentos{   
    font-size: 0.9em;      
    text-align: center;    
}




</style>